import type { Transition } from "@uirouter/core";

import Sentry from "@similarweb/sentry-logger";

import { DEFAULT_INFLUENCE_VIEW } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/sources-report/domain-influence/consts";
import { InfluenceViews } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/sources-report/domain-influence/types";
import type { transitionHookFn } from "app/routes/handlers/redirectFunctions/redirectPipe";

export const onRedirectToLLMSourcesReport = (): transitionHookFn => {
    return (transition: Transition) => {
        const toParams = transition.params();
        try {
            //validate view
            if (!toParams?.view || !InfluenceViews.some((view) => view.toLowerCase() === toParams.view.toLowerCase())) {
                return {
                    params: {
                        ...toParams,
                        view: DEFAULT_INFLUENCE_VIEW,
                    },
                };
            }
        } catch (error) {
            Sentry.errorTracker({
                e: error,
                message: "Error in LLM sources report redirect",
                level: "error",
                params: {
                    extra: {
                        toParams,
                    },
                },
            });
            return null;
        }
    };
};
